'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SplitSection = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    padding: 1em;\n    ', ';\n\n    text-align: left;\n\n    & > ', ' {\n        display: grid;\n        grid-gap: 2em 6em;\n\n        & > ', ' {\n            ', '\n        }\n    }\n\n    & ', ' {\n        text-align: left;\n\n        &:after {\n            position: initial;\n            margin-left: 0;\n        }\n    }\n\n    @media ', ' {\n        padding: 3em 1.5em;\n        & > ', ' {\n            grid-template-columns: 1fr 1fr;\n\n            & > ', ' {\n                ', '\n                ', '\n            }\n\n            & > div {\n                order: ', ';\n            }\n        }\n    }\n'], ['\n    padding: 1em;\n    ', ';\n\n    text-align: left;\n\n    & > ', ' {\n        display: grid;\n        grid-gap: 2em 6em;\n\n        & > ', ' {\n            ', '\n        }\n    }\n\n    & ', ' {\n        text-align: left;\n\n        &:after {\n            position: initial;\n            margin-left: 0;\n        }\n    }\n\n    @media ', ' {\n        padding: 3em 1.5em;\n        & > ', ' {\n            grid-template-columns: 1fr 1fr;\n\n            & > ', ' {\n                ', '\n                ', '\n            }\n\n            & > div {\n                order: ', ';\n            }\n        }\n    }\n']);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styles = require('./styles');

var _Section = require('./Section');

var _SectionTitle = require('./SectionTitle');

var _SectionImage = require('./SectionImage');

var _SectionContent = require('./SectionContent');

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
/*:: import type {ComponentType} from 'react' */
/*:: import type {SectionProps} from './Section' */


var TitleWrap = (0, _helpers.wrapComponent)(_SectionTitle.SectionTitle);

var includes = function includes(prop, value) {
    return prop && prop.includes(value);
};
var setMarginStyle = function setMarginStyle(mesure, location) {
    return function (_ref) {
        var align = _ref.align,
            overflow = _ref.overflow;

        var multiplier = 0;
        if (includes(align, location)) {
            multiplier = 1;
        }
        if (includes(overflow, location)) {
            multiplier = 1.8;
        }

        return 'margin-' + location + ': calc( ' + multiplier + ' * ' + mesure + ');';
    };
};

/*::
type Props = {|
    ...SectionProps,
    reverse?: bool,
    align?: string,
    overflow?: string,
    image: string,
|}
*/
var SplitSection /*: ComponentType<Props> */ = exports.SplitSection = (0, _styledComponents2.default)(function (props) {
    return React.createElement(
        'section',
        { className: props.className },
        React.createElement(
            _SectionContent.SectionContent,
            null,
            React.createElement(
                'div',
                null,
                TitleWrap(props.title),
                props.children
            ),
            React.createElement(_SectionImage.SectionImage, { src: props.image })
        )
    );
})(_templateObject, _Section.colorScheme, _SectionContent.SectionContent, _SectionImage.SectionImage, setMarginStyle('-1em', 'bottom'), _SectionTitle.SectionTitle, _styles.styles.media.tablet, _SectionContent.SectionContent, _SectionImage.SectionImage, setMarginStyle('-3em', 'bottom'), setMarginStyle('-3em', 'top'), function (props) {
    return props.reverse ? '1' : '0';
});
SplitSection.displayName = 'SplitSection';


//////////////////
// WEBPACK FOOTER
// ../tutellus-ui/lib/SplitSection.js
// module id = 644
// module chunks = 0